/**
 * Data Objects Module
 * 
 * This module contains static data objects used throughout the application,
 * including featured products, categories, navigation menus, and UI elements.
 */
import { 
  Truck,
  Power, Building2, Zap, Ruler, HardHat, Droplet, Package, Flame,
  Wrench
} from 'lucide-react';

/**
 * Featured products displayed on the homepage and promotional sections
 * Each product contains complete information including:
 * - Basic details (id, name, price)
 * - Categorization (category, subCategory)
 * - Inventory information (availability, inStock, qty_instock)
 * - Product specifications (model, sku, features)
 * - Display properties (main_image, tag, isNew)
 */
export const featured_products = [
  {
    id: 1,
    name: "Power Drill",
    price: 199.99,
    originalPrice: 299.99,
    category: "Power Tools",
    subCategory: "Power Tools",
    brand: "Dewalt",
    description: "ATOMIC 20V Max Lithium-Ion Brushless Cordless Compact 1/4 in. Impact Driver Kit with 2.0Ah Battery, Charger and Bag",
    rating: 3.5,
    reviewsCount: 200,
    availability: "Out of Stock",
    inStock: false,
    qty_instock: 0,
    model: "DCD771C2",
    sku: "1234567890",
    main_image: "https://images.thdstatic.com/productImages/c751e460-58f0-405e-8eed-a2ed15997670/svn/dewalt-power-drills-dcd771c2-64_600.jpg",
    tag: "DISCOUNT",
    isNew: true,
    features: [
      "Variable speed control",
      "Ergonomic grip design",
      "Brushless motor",
      "20V lithium-ion battery"
    ]
  },
  {
    id: 2,
    name: "Circular Saw",
    price: 159.99,
    originalPrice: 199.99,
    category: "Power Tools",
    subCategory: "Power Tools",
    brand: "Milwaukee",
    description: "M18 FUEL 18-Volt Lithium-Ion Brushless Cordless 7-1/4 in. Circular Saw",
    rating: 4.5,
    reviewsCount: 150,
    availability: "In Stock",
    inStock: true,
    qty_instock: 25,
    model: "2732-20",
    sku: "987654321",
    main_image: "https://images.thdstatic.com/productImages/1b43c3c6-2c82-4a89-a14c-2b91f6a2f299/svn/milwaukee-circular-saws-2732-20-64_600.jpg",
    tag: "BESTSELLER",
    isNew: false,
    features: [
      "POWERSTATE Brushless Motor",
      "REDLINK PLUS Intelligence",
      "REDLITHIUM Battery Pack",
      "LED Light"
    ]
  },
  {
    id: 3,
    name: "Hammer",
    price: 29.99,
    originalPrice: 34.99,
    category: "Hand Tools",
    subCategory: "Hand Tools",
    brand: "Stanley",
    description: "20 oz. Smooth Face Steel Head Hammer with Fiberglass Handle",
    rating: 4.0,
    reviewsCount: 300,
    availability: "In Stock",
    inStock: true,
    qty_instock: 50,
    model: "51-624",
    sku: "456789123",
    main_image: "https://images.thdstatic.com/productImages/a1b2c3d4-e5f6-g7h8-i9j0-k1l2m3n4o5p6/svn/stanley-hammers-51-624-64_600.jpg",
    tag: "",
    isNew: false,
    features: [
      "Fiberglass handle reduces vibration",
      "Textured grip for control",
      "Steel head for durability",
      "Balanced weight distribution"
    ]
  },
  {
    id: 4,
    name: "Safety Goggles",
    price: 12.99,
    originalPrice: 15.99,
    category: "Safety Equipment",
    subCategory: "Safety Equipment",
    brand: "3M",
    description: "Clear Anti-Fog Safety Goggles with Adjustable Strap",
    rating: 4.2,
    reviewsCount: 250,
    availability: "In Stock",
    inStock: true,
    qty_instock: 100,
    model: "91252-80025",
    sku: "789123456",
    main_image: "https://images.thdstatic.com/productImages/b2c3d4e5-f6g7-h8i9-j0k1-l2m3n4o5p6q7/svn/3m-safety-goggles-91252-80025-64_600.jpg",
    tag: "ESSENTIAL",
    isNew: false,
    features: [
      "Anti-fog coating",
      "UV protection",
      "Adjustable elastic strap",
      "Impact resistant"
    ]
  },
  {
    id: 5,
    name: "Power Drill",
    price: 199.99,
    originalPrice: 299.99,
    category: "Power Tools",
    subCategory: "Power Tools",
    brand: "Dewalt",
    description: "ATOMIC 20V Max Lithium-Ion Brushless Cordless Compact 1/4 in. Impact Driver Kit with 2.0Ah Battery, Charger and Bag",
    rating: 3.5,
    reviewsCount: 200,
    availability: "Out of Stock",
    inStock: false,
    qty_instock: 1,
    model: "DCD771C2",
    sku: "1234567890",
    main_image: "https://images.thdstatic.com/productImages/c751e460-58f0-405e-8eed-a2ed15997670/svn/dewalt-power-drills-dcd771c2-64_600.jpg",
    tag: "DISCOUNT",
    isNew: true,
    features: [
      "Variable speed control",
      "Ergonomic grip design",
      "Brushless motor",
      "20V lithium-ion battery",
      "LED work light",
      "Keyless chuck"
    ],
    specifications: {
      "Power": "20V",
      "Chuck Size": "1/2 inch",
      "Weight": "3.5 lbs",
      "Battery Type": "Lithium-Ion",
      "Speed": "0-2000 RPM",
      "Torque": "600 in-lbs"
    },
    images: [
      "https://images.thdstatic.com/productImages/8dc92dd0-34f8-4bb0-8d4f-2036b146038b/svn/dewalt-impact-drivers-dcf809d1-64_600.jpg",
      "https://images.thdstatic.com/productImages/2054abdb-5865-4a34-b97e-2d1c204fd49c/svn/dewalt-impact-drivers-dcf809d1-e1_600.jpg",
      "https://images.thdstatic.com/productImages/83534515-3560-4c82-9fb1-74731f764949/svn/dewalt-impact-drivers-dcf809d1-40_600.jpg",
      "https://images.thdstatic.com/productImages/1681de91-ecce-4f5b-a1d5-4777a7a286b7/svn/dewalt-impact-drivers-dcf809d1-31_600.jpg"
    ]
  },
  // ... other featured_products ...
];

export const search_categories = [
  'All Categories',
  'Appliances',
  'Arts, Crafts & Sewing',
  'Automotive',
  'Baby Products',
  'Beauty & Personal Care',
  'Books',
  'Cell Phones & Accessories',
  'Clothing, Shoes, Luggage & Accessories',
  'Electronics',
  'Health & Household',
  'Home & Kitchen',
  'Industrial & Scientific',
  'Musical Instruments & Accessories',
  'Office Products',
  'Patio, Lawn & Garden',
  'Pet Supplies',
  'Sports & Outdoors',
  'Tools & Home Improvement',
  'Toys & Games',
  'Other'
];

export const slides = [
  {
    id: 1,
    title: "Big choice of",
    subtitle: "Plumbing products",
    description: "Professional tools and accessories for plumbing and repair work",
    buttonText: "Shop Now",
    image: "https://carlislesupplies.com/wp-content/uploads/2024/09/main-photo-1.jpg",
    color: "#FFD700"
  },
  {
    id: 2,
    title: "Big choice of",
    subtitle: "Plumbing products",
    description: "Professional tools and accessories for plumbing and repair work",
    buttonText: "Shop Now",
    image: "https://carlislesupplies.com/wp-content/uploads/2024/09/main-photo-1.jpg",
    color: "#FFD700"
  },
  // ... other slides ...
];

export const features = [
  {
    id: 1,
    icon: <Truck size={32} />,
    title: "Free Shipping",
    description: "For orders from $50",
    color: "#4CAF50"
  },
  // ... other features ...
];

export const menu_categories = [
  {
    id: 1,
    name: 'Appliances',
    icon: <Power size={20} />,
    subCategories: [
      'Refrigerators', 'Dishwashers', 'Washing Machines', 
      'Dryers', 'Ovens', 'Microwaves'
    ]
  },
  {
    id: 2,
    name: 'Arts, Crafts & Sewing',
    icon: <Wrench size={20} />,
    subCategories: [
      'Sewing Machines', 'Craft Supplies', 'Paints & Brushes',
      'Knitting & Crochet', 'Scrapbooking', 'Jewelry Making'
    ]
  },
  {
    id: 3,
    name: 'Automotive',
    icon: <Power size={20} />,
    subCategories: [
      'Auto Parts', 'Tools & Equipment', 'Car Care Products',
      'Tires & Wheels', 'Car Electronics', 'Accessories'
    ]
  },
  {
    id: 4,
    name: 'Baby Products',
    icon: <Building2 size={20} />,
    subCategories: [
      'Strollers', 'Car Seats', 'Baby Clothing',
      'Diapers & Wipes', 'Nursery Furniture', 'Feeding'
    ]
  },
  {
    id: 5,
    name: 'Beauty & Personal Care',
    icon: <Zap size={20} />,
    subCategories: [
      'Makeup', 'Skin Care', 'Hair Care',
      'Bath & Body', 'Fragrances', 'Personal Grooming'
    ]
  },
  {
    id: 6,
    name: 'Books',
    icon: <Power size={20} />,
    subCategories: [
      'Fiction', 'Non-Fiction', 'Textbooks',
      'Children\'s Books', 'Cookbooks', 'Reference Books'
    ]
  },
  {
    id: 7,
    name: 'Cell Phones & Accessories',
    icon: <Ruler size={20} />,
    subCategories: [
      'Smartphones', 'Tablets', 'Phone Cases',
      'Chargers & Cables', 'Headphones', 'Smartwatches'
    ]
  },
  {
    id: 8,
    name: 'Clothing, Shoes, Luggage & Accessories',
    icon: <HardHat size={20} />,
    subCategories: [
      'Men\'s Clothing', 'Women\'s Clothing', 'Kids\' Clothing',
      'Shoes', 'Handbags', 'Luggage & Travel Accessories'
    ]
  },
  {
    id: 9,
    name: 'Electronics',
    icon: <Droplet size={20} />,
    subCategories: [
      'TVs', 'Computers', 'Cameras',
      'Speakers', 'Wearables', 'Smart Home Devices'
    ]
  },
  {
    id: 10,
    name: 'Health & Household',
    icon: <Package size={20} />,
    subCategories: [
      'Vitamins & Supplements', 'Household Essentials',
      'Personal Care Appliances', 'First Aid Supplies',
      'Fitness Equipment', 'Health Monitors'
    ]
  },
  {
    id: 11,
    name: 'Home & Kitchen',
    icon: <Flame size={20} />,
    subCategories: [
      'Furniture', 'Bedding & Bath', 'Home Decor',
      'Kitchen Appliances', 'Cookware & Bakeware', 'Home Improvement'
    ]
  },
  {
    id: 12,
    name: 'Industrial & Scientific',
    icon: <Power size={20} />,
    subCategories: [
      'Lab Equipment', 'Janitorial & Sanitation', 
      'Retail & Restaurant Supplies', 'Packaging & Shipping',
      'Occupational Safety', 'Science & Engineering Supplies'
    ]
  },
  {
    id: 13,
    name: 'Musical Instruments & Accessories',
    icon: <Ruler size={20} />,
    subCategories: [
      'Guitars', 'Pianos', 'Drums',
      'Microphones', 'Recording Equipment', 'Sheet Music'
    ]
  },
  {
    id: 14,
    name: 'Office Products',
    icon: <HardHat size={20} />,
    subCategories: [
      'Printers & Scanners', 'Office Furniture', 'Desk Supplies',
      'Filing & Storage', 'Presentation Supplies', 'Business Machines'
    ]
  },
  {
    id: 15,
    name: 'Patio, Lawn & Garden',
    icon: <Droplet size={20} />,
    subCategories: [
      'Outdoor Furniture', 'Gardening Tools', 'Lawn Mowers',
      'Grills & Outdoor Cooking', 'Patio Decor', 'Outdoor Lighting'
    ]
  },
  {
    id: 16,
    name: 'Pet Supplies',
    icon: <Package size={20} />,
    subCategories: [
      'Dog Supplies', 'Cat Supplies', 'Fish Supplies',
      'Small Animal Supplies', 'Bird Supplies', 'Reptile Supplies'
    ]
  },
  {
    id: 17,
    name: 'Sports & Outdoors',
    icon: <Flame size={20} />,
    subCategories: [
      'Exercise & Fitness', 'Team Sports', 'Outdoor Recreation',
      'Hunting & Fishing', 'Camping & Hiking', 'Sports Accessories'
    ]
  },
  {
    id: 18,
    name: 'Tools & Home Improvement',
    icon: <Power size={20} />,
    subCategories: [
      'Power Tools', 'Hand Tools', 'Hardware',
      'Building Supplies', 'Electrical', 'Plumbing'
    ]
  },
  {
    id: 19,
    name: 'Toys & Games',
    icon: <Ruler size={20} />,
    subCategories: [
      'Action Figures', 'Dolls', 'Board Games',
      'Video Games', 'Puzzles', 'Arts & Crafts'
    ]
  },
  {
    id: 20,
    name: 'Other',
    icon: <HardHat size={20} />,
    subCategories: [
      'Miscellaneous', 'Unique Finds', 'Novelty Items',
      'Hard to Find Items', 'Collectibles', 'Subscription Boxes'
    ]
  }
];